module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAA40lEQVR4Ae3RsRFBQRhG0VeAApSgCF0oVAkCoQKUoACh4NlAtgnRHZwz8+e791sAAAAAAAAAAAAAAAD4Pttxl3H7ZVY5jDuN2/xD/Ou4ddx9GqGL/3i96RyMkMRfpxH6+GswQhV/HqGOX48QxJ9HqOL/+gin6XNvjNDEn+64/IDduNvHI/Txb6+3D0ZI4xuhj2+EPr4R+vhG6OMboY9vhD6+Efr4RujjG6GPb4Q4vhHi+EYI4hshi2+EPr4R+vhG6OMboY9vhD6+Efr4RujjG0H80O7P4wMAAAAAAAAAAAAAAPAEVqzcejkbwqEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-icon.png
// module id = 92
// module chunks = 0